import { render } from "./ClassItem.vue?vue&type=template&id=10358af2&scoped=true"
import script from "./ClassItem.vue?vue&type=script&lang=js"
export * from "./ClassItem.vue?vue&type=script&lang=js"

import "./ClassItem.vue?vue&type=style&index=0&id=10358af2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10358af2"]])

export default __exports__